module.exports = __webpack_public_path__ + "static/media/consumer-square.fe79ec0b.jpg";